import { supabase } from "@/integrations/supabase/client";

export type StaffActionType =
  | "login"
  | "lead_viewed"
  | "status_updated"
  | "note_added"
  | "email_sent"
  | "lead_assigned";

// Fire-and-forget activity logger. Never throws into the caller.
export async function logActivity(
  userId: string,
  agencyId: string,
  actionType: StaffActionType,
  leadId?: string | null,
): Promise<void> {
  try {
    await supabase.from("staff_activity_log").insert({
      user_id: userId,
      agency_id: agencyId,
      action_type: actionType,
      lead_id: leadId ?? null,
    });
  } catch (err) {
    // Swallow — activity logging must never break a user action.
    console.warn("logActivity failed", err);
  }
}
